<div class="network-error-container">
  <div class="network-popup-card">
    <!-- Close Button -->
    <!-- <button class="network-close-btn" (click)="closePopup()">&times;</button> -->
    <!-- <div class="network-close-btn" ><mat-icon (click)="closePopup()">close</mat-icon></div> -->

    <!-- Top Image -->
    <img
      class="network-popup-img"
      src="assets/images/Network-Issue-image.png"
      alt="Network Error"
    />

    <!-- Content -->
    <div class="network-popup-content">
      <div class="network-popup-header">
        <img
          src="assets/images/logos/mobile_autoverse_logo.svg"
          alt="Autoverse Logo"
          class="network-logo"
        />
        <span class="network-logo-text">AUTOVERSE</span>
      </div>
      <div class="network-popup-message">
        <div class="network-popup-title">Oh no. No internet found.</div>
        <div class="network-popup-subtext">
          Check your connection and try again.
        </div>
      </div>
      <button class="network-popup-btn" (click)="tryAgain()">
        Try Again
      </button>
      
    </div>
  </div>
</div>
